export default __webpack_public_path__ + "static/media/kitchen3-after1-1920w.1d9a65f0.webp";